import { Component, ElementRef } from '@angular/core';
import {
  ActivatedRoute,
  ChildrenOutletContexts,
  Router,
} from '@angular/router';
import { slideInAnimation } from './slideInAnimation';
import { AuthService } from './services/common/auth.service';
import { HealthAppService } from './services/explore-health/health-app.service';
import { TenantService } from './services/explore-health/tenant.service';
import { SnackbarService } from './services/common/snackbar.service';
import { Constants } from './utils/constants';
import { MatDialog } from '@angular/material/dialog';
import { UserFlowComponent } from './components/user-flow/user-flow.component';
import { NotificationService } from './pages/notification/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [slideInAnimation],
})
export class AppComponent {
  title = 'EY Impact';

  constructor(
    private readonly contexts: ChildrenOutletContexts,
    private readonly auth: AuthService,
    private readonly tenantService: TenantService,
    private readonly haService: HealthAppService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly snack: SnackbarService,
    private readonly router: Router,
    private readonly elRef: ElementRef,
    private readonly dialog: MatDialog,
    private readonly notifyService: NotificationService
  ) {}

  ngAfterViewInit() {
    let nounce = this.elRef.nativeElement.getAttribute('ngCspNonce');
    localStorage.setItem(Constants.CSP_NOUNCE_STORAGE, nounce);
  }

  onPageScroll(event: any) {
    if (this.router.url.includes('/county-health')) {
      this.haService.outcomeFilterScrollSubject.next(event);
    }

    if (this.router.url.includes('/state-health')) {
      this.haService.disparityFilterScrollSubject.next(event);
    }
  }

  ngOnInit() {
    if (this.auth.hasLoggedIn) {
      this.tenantService.triggerLogoutEvent();
      setTimeout(() => {
        this.notifyService.createSocketInstance();
      }, 2000);
    }

    this.haService.startUserGuide$.subscribe(() => {
      this.openUserFlowPopup();
    });
    this.configure();
    this.readRouteParams();
  }

  configure() {
    let issuer = this.tenantService.getIssuers();
    if (issuer != null) {
      this.tenantService.initiateCodeFlowWithConfig(
        this.tenantService.formAuthConfig(issuer, false),
        false,
        true
      );
    }
  }

  readRouteParams() {
    this.activatedRoute.queryParams.subscribe((queryParams: any) => {
      if (!this.auth.isAuthenticated() && window.location.search.length > 0) {
        if (window.location.search.includes(`code=`)) {
          this.router.navigateByUrl('/login-callback' + window.location.search);
        } else if (
          window.location.search.includes('error=') &&
          window.location.search.includes('error_description=')
        ) {
          this.snack.openErrorBar(
            this.router.parseUrl(window.location.search)?.queryParams[
              'error_description'
            ] ?? 'Something went wrong! Please login agian..'
          );
        }
      }
    });
  }

  isLoginCallBack(): boolean {
    return this.router.url?.includes('/login-callback');
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'animation'
    ];
  }
  openUserFlowPopup() {
    let dialogRef = this.dialog.open(UserFlowComponent, {
      width: '834px',
      height: '236px',
      panelClass: 'custom-class',
      backdropClass: 'blurred-backdrop',
      data: false,
    });
    dialogRef.afterClosed().subscribe((result: any) => {});
  }
}
